<template>
    <div>
        <DemographicsInformation class="mb-2" />
        <ServiceLocations class="mb-2" />
        <FacesheetComments />
    </div>
</template>

<script src="./Demographics.ts"></script>
